import React, { Component } from 'react';
// import * as _ from 'lodash'

import './index.css';

import State from '../State'
import {commaFormat} from '../Helpers'

class Tooltip extends Component {
  render() {
    let t = State.tooltip

    if(!t) {
      return null
    }

    let style = {
      top: (t.y + 5) + 'px',
      left: (t.x - 245) + 'px'
    }

    let showCampaignName = true //_.find(State.nestFields, {name: 'RegulatedEntityName', active: false})
    let shownSupplierName = true //_.find(State.nestFields, {name: 'SupplierName', active: false})
    let showClickForInvoice = t.d.RedactedSupportingInvoiceId

    // console.log(t.d)

    return (
      <div id="tooltip" style={style} >
        <table>
          <tbody>
            {showCampaignName && <tr><td>Campaign</td><td>{t.d.RegulatedEntityName}</td></tr>}
            {shownSupplierName && <tr><td>Supplier</td><td>{t.d.SupplierName}</td></tr>}
            <tr><td>Amount</td><td>£{commaFormat(t.d.TotalExpenditure)}</td></tr>
            <tr><td>Incurred</td><td>{t.d.DateIncurred}</td></tr>
          </tbody>
        </table>
        {showClickForInvoice && <div>Click to view invoice</div>}
      </div>
    )
  }
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/Tooltip/index.js